import { render, staticRenderFns } from "./PageItemWithSinisters.vue?vue&type=template&id=1e8e3ef8&scoped=true"
import script from "./PageItemWithSinisters.vue?vue&type=script&lang=ts"
export * from "./PageItemWithSinisters.vue?vue&type=script&lang=ts"
import style0 from "./PageItemWithSinisters.vue?vue&type=style&index=0&id=1e8e3ef8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8e3ef8",
  null
  
)

export default component.exports